// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"ef15c11d","345":"ab795025","448":"5a1ba042","453":"8a9b41f1","564":"e1369dd6","843":"b69bf9bd","880":"444421b4","924":"7da1fe12"}[chunkId] + ".chunk.js";
};